function GrowthGridMeasurementIcon({
  size = 36,
  className = '',
  onClick = (event) => {}
}: {
  size?: number;
  className?: string;
  onClick?: (event) => void;
}) {
  return (
    <span className={className} onClick={onClick}>
      <svg
        xmlns='http://www.w3.org/2000/svg'
        width={size}
        height={(size * 32) / 33}
        viewBox='0 0 33 32'
      >
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M13.5 1C14.0523 1 14.5 1.44772 14.5 2L14.5 30C14.5 30.5523 14.0523 31 13.5 31C12.9477 31 12.5 30.5523 12.5 30L12.5 2C12.5 1.44772 12.9477 1 13.5 1Z'
          fill='currentColor'
        />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M24.5 2C24.5 2.55228 24.0523 3 23.5 3L13.5 3C12.9477 3 12.5 2.55228 12.5 2C12.5 1.44772 12.9477 1 13.5 1L23.5 1C24.0523 1 24.5 1.44772 24.5 2Z'
          fill='currentColor'
        />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M24.5 9C24.5 9.55228 24.0523 10 23.5 10L13.5 10C12.9477 10 12.5 9.55228 12.5 9C12.5 8.44772 12.9477 8 13.5 8L23.5 8C24.0523 8 24.5 8.44772 24.5 9Z'
          fill='currentColor'
        />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M24.5 16C24.5 16.5523 24.0523 17 23.5 17H13.5C12.9477 17 12.5 16.5523 12.5 16C12.5 15.4477 12.9477 15 13.5 15L23.5 15C24.0523 15 24.5 15.4477 24.5 16Z'
          fill='currentColor'
        />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M24.5 23C24.5 23.5523 24.0523 24 23.5 24H13.5C12.9477 24 12.5 23.5523 12.5 23C12.5 22.4477 12.9477 22 13.5 22H23.5C24.0523 22 24.5 22.4477 24.5 23Z'
          fill='currentColor'
        />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M24.5 30C24.5 30.5523 24.0523 31 23.5 31H13.5C12.9477 31 12.5 30.5523 12.5 30C12.5 29.4477 12.9477 29 13.5 29H23.5C24.0523 29 24.5 29.4477 24.5 30Z'
          fill='currentColor'
        />
      </svg>
    </span>
  );
}

export default GrowthGridMeasurementIcon;
